export class Comment {
	static activeReplyForm = null;
	elementSelector = '.js-comment';

	replyButtonSelector = '.comment__reply-button';
	replyBlockSelector = '.comment__reply-block';
	replyBlockActiveClass = 'comment__reply-block--active';

	showRepliesButtonSelector = '.comment-show-replies';
	showRepliesButtonActiveClass = 'comment-show-replies--active';
	repliesSelector = '.comment__replies';
	repliesActiveClass = 'comment__replies--active';

	constructor(element) {
		if (!element) return;
		this.element = element;

		this.init();
	}

	init() {
		this.replyButton = this.element.querySelector(this.replyButtonSelector);
		this.replyBlock = this.element.querySelector(this.replyBlockSelector);
		this.showRepliesButton = this.element.querySelector(this.showRepliesButtonSelector);
		this.replies = this.element.querySelector(this.repliesSelector);

		this.element.addEventListener('click', this.handleClick);
	}

	handleClick = (event) => {
		const replyButton = event.target.closest(this.replyButtonSelector);
		if (replyButton && replyButton.closest(this.elementSelector) === this.element) {
			this.toggleReplyForm();
			return;
		}

		const showRepliesButton = event.target.closest(this.showRepliesButtonSelector);
		if (showRepliesButton && showRepliesButton.closest(this.elementSelector) === this.element) {
			this.toggleReplies();
		}
	};

	isRepliesExpanded() {
		if (!this.replies) return false;
		return this.replies.classList.contains(this.repliesActiveClass);
	}

	expandReplies() {
		if (!this.replies || !this.showRepliesButton) return;
		if (this.isRepliesExpanded()) return;

		this.replies.classList.add(this.repliesActiveClass);
		this.showRepliesButton.classList.add(this.showRepliesButtonActiveClass);

		this.dispatch('comment:repliesExpand', { expanded: true });
	}

	collapseReplies() {
		if (!this.replies || !this.showRepliesButton) return;
		if (!this.isRepliesExpanded()) return;

		this.replies.classList.remove(this.repliesActiveClass);
		this.showRepliesButton.classList.remove(this.showRepliesButtonActiveClass);

		this.dispatch('comment:repliesCollapse', { expanded: false });
	}

	toggleReplies() {
		this.isRepliesExpanded() ? this.collapseReplies() : this.expandReplies();
	}

	isReplyFormOpen() {
		if (!this.replyBlock) return false;
		return this.replyBlock.classList.contains(this.replyBlockActiveClass);
	}

	openReplyForm() {
		if (!this.replyBlock || !this.replyButton) return;

		if (Comment.activeReplyForm && Comment.activeReplyForm !== this) {
			Comment.activeReplyForm.closeReplyForm({ reason: 'switch' });
		}

		if (this.isReplyFormOpen()) return;

		this.replyBlock.classList.add(this.replyBlockActiveClass);
		Comment.activeReplyForm = this;

		this.dispatch('comment:replyFormOpen', { open: true });
	}

	closeReplyForm({ reason = 'close' } = {}) {
		if (!this.replyBlock || !this.replyButton) return;
		if (!this.isReplyFormOpen()) return;

		this.replyBlock.classList.remove(this.replyBlockActiveClass);

		if (Comment.activeReplyForm === this) {
			Comment.activeReplyForm = null;
		}

		this.dispatch('comment:replyFormClose', { open: false, reason });
	}

	toggleReplyForm() {
		if (this.isReplyFormOpen()) this.closeReplyForm({ reason: 'toggle' });
		else this.openReplyForm();
	}

	dispatch(name, detail = {}) {
		this.element.dispatchEvent(
			new CustomEvent(name, {
				bubbles: true,
				detail: {
					...detail,
					element: this.element,
				},
			}),
		);
	}
}
